import {useDispatch, useSelector} from 'react-redux'
import {useMemo, useEffect} from 'react'
import {
  setDistributionDimensionList as setDistributionDimensionListAction,
  setDistributionLabel as setDistributionLabelAction,
  setShowPopulationDistribution as setShowPopulationDistributionAction,
  setSelectedDimension as setSelectedDimensionAction,
  selectDistributionDimensionList,
  selectDistributionLabel,
  selectShowPopulationDistribution,
  selectSelectedDimension,
  setIsInitialized as setIsInitializedAction,
  selectIsPopulationDistributionDimensionInitialized
} from '../slices/populationDistributionDimensionSlice'
import {useConfig} from './config'

export const useDistributionDimension = () => {
  const dispatch = useDispatch()
  const isInitialized = useSelector(selectIsPopulationDistributionDimensionInitialized)
  const distributionDimensionList = useSelector(selectDistributionDimensionList)
  const distributionLabel = useSelector(selectDistributionLabel)
  const showPopulationDistribution = useSelector(selectShowPopulationDistribution)
  const selectedDimension = useSelector(selectSelectedDimension)

  const configData = useConfig() || {}
  const dimensionDistribution = configData?.distributionDimensionConfig || []

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (isInitialized) {
      return
    }
    dispatch(setIsInitializedAction(true))

    dispatch(setDistributionDimensionListAction(dimensionDistribution))
    if (
      dimensionDistribution &&
      Array.isArray(dimensionDistribution.populationDistributionDimensions) &&
      dimensionDistribution.populationDistributionDimensions.length > 0
    )
      dispatch(setSelectedDimensionAction(dimensionDistribution.populationDistributionDimensions[0]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized])

  const setDistributionLabel = (value) => {
    dispatch(setDistributionLabelAction(value))
  }

  const setShowPopulationDistribution = (value) => {
    dispatch(setShowPopulationDistributionAction(value))
  }

  const setSelectedDimension = (value) => {
    dispatch(setSelectedDimensionAction(value))
  }

  return useMemo(
    () => ({
      distributionDimensionList,
      distributionLabel,
      setDistributionLabel,
      showPopulationDistribution,
      setShowPopulationDistribution,
      selectedDimension,
      setSelectedDimension
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [distributionDimensionList, distributionLabel, showPopulationDistribution, selectedDimension]
  )
}
